export const DEFAULT_LANGUAGE = "tr";

export const ROUTE_PATHS = {
  tr: {
    home: "",
    pricing: "fiyatlandirma",
    integration_pricing: "entegrasyon-paketleri-fiyatlandirma",
    marketplace_integration: "pazaryeri-cozumleri",
    shipping_integration: "kargo-entegrasyonlari",
    xml_integration: "xml-entegrasyonlari",
    webservis_integration: "webservis-entegrasyonlari",
    analytics_integration: "analistik-entegrasyonlari",
    catalog_management: "katalog-yonetimi",
    stock_and_price_management: "stok-ve-fiyat-yonetimi",
    order_management: "siparis-yonetimi",
    accounting: "on-muhasebe-sistemi",
    e_invoice_integration: "e-fatura-aktarim-sistemi",
    contact: "iletisim",
    trendyol_integration: "trendyol-entegrasyonu",
    hepsiburada_integration: "hepsiburada-entegrasyonu",
    n11_integration: "n11-entegrasyonu",
    ciceksepeti_integration: "ciceksepeti-entegrasyonu",
    pttavm_integration: "pttavm-entegrasyonu",
    akakce_integration: "akakce-entegrasyonu",
    amazon_integration: "amazon-entegrasyonu",
    rgsyazilim_integration: "rgsyazilim-entegrasyonu",
    opencart_integration: "opencart-entegrasyonu",
    shopify: "shopify",
    shopify_integration: "shopify-entegrasyonu",
    shopify_app_development: "shopify-uygulama-gelistirme",
    shopify_store_setup: "shopify-magaza-kurulumu",
    shopify_migration: "shopify-gecis",
    shopify_theme_development: "shopify-tema-gelistirme",
    shopify_theme_customization: "shopify-tema-ozellestirme",
    shopify_maintenance: "shopify-bakim-destek",
    shopify_plus: "shopify-plus",
    enterprise_solutions: "enterprise-cozumleri",
    b2b_ecommerce: "b2b-e-ticaret",
    wholesale_solutions: "toptan-satis-cozumleri",
    shopify_plus_migration: "shopify-plus-gecis",
    custom_development: "ozel-gelistirme",
    wix_integration: "wix-entegrasyonu",
    woocommerce_integration: "woocommerce-entegrasyonu",
    paytr_integration: "paytr-entegrasyonu",
    bizimhesap_integration: "bizimhesap-entegrasyonu",
    dia_integration: "dia-entegrasyonu",
    edm_integration: "edm-entegrasyonu",
    parasut_integration: "parasut-entegrasyonu",
    uyumsoft_integration: "uyumsoft-entegrasyonu",
    aras_cargo: "aras-kargo",
    yurtici_cargo: "yurtici-kargo",
    mng_cargo: "mng-kargo",
    ups_cargo: "ups-kargo",
    ptt_cargo: "ptt-kargo",
    hepsijet_cargo: "hepsijet-kargo",
    sendeo_cargo: "sendeo-kargo",
    surat_cargo: "surat-kargo",
    about: "hakkimizda",
    career: "kariyer",
    dealership: "bayilik",
    women_entrepreneurs: "kadin-girisimciler",
    suggestion: "oneri-sikayet",
    faq_page: "sss",
    cookie: "cerez",
    data_security: "veri-guvenligi",
    privacy: "gizlilik",
    user_agreement: "kullanici-sozlesmesi",
    contract: "aydinlatma-metni"
  },
  en: {
    home: "en",
    pricing: "pricing",
    integration_pricing: "integration-packages-pricing",
    marketplace_integration: "marketplace-integration",
    shipping_integration: "shipping-integration",
    xml_integration: "xml-integration",
    webservice_integration: "webservis-integration",
    analytics_integration: "analytics-integration",
    catalog_management: "catalog-management",
    stock_and_price_management: "stock-and-price-management",
    order_management: "order-management",
    accounting: "accounting",
    e_invoice_integration: "e-invoice-integration",
    contact: "contact",
    trendyol_integration: "trendyol-integration",
    hepsiburada_integration: "hepsiburada-integration",
    n11_integration: "n11-integration",
    ciceksepeti_integration: "ciceksepeti-integration",
    pttavm_integration: "pttavm-integration",
    akakce_integration: "akakce-integration",
    amazon_integration: "amazon-integration",
    rgsyazilim_integration: "rgsyazilim-integration",
    opencart_integration: "opencart-integration",
    shopify: "shopify",
    shopify_integration: "shopify-integration",
    shopify_app_development: "shopify-app-development",
    shopify_plus: "shopify-plus",
    enterprise_solutions: "enterprise-solutions",
    b2b_ecommerce: "b2b-ecommerce",
    wholesale_solutions: "wholesale-solutions",
    shopify_plus_migration: "shopify-plus-migration",
    custom_development: "custom-development",
    wix_integration: "wix-integration",
    woocommerce_integration: "woocommerce-integration",
    paytr_integration: "paytr-integration",
    bizimhesap_integration: "bizimhesap-integration",
    dia_integration: "dia-integration",
    edm_integration: "edm-integration",
    parasut_integration: "parasut-integration",
    uyumsoft_integration: "uyumsoft-integration",
    aras_cargo: "aras-cargo",
    yurtici_cargo: "yurtici-cargo",
    mng_cargo: "mng-cargo",
    ups_cargo: "ups-cargo",
    ptt_cargo: "ptt-cargo",
    hepsijet_cargo: "hepsijet-cargo",
    sendeo_cargo: "sendeo-cargo",
    surat_cargo: "surat-cargo",
    about: "about",
    career: "career",
    dealership: "dealership",
    women_entrepreneurs: "women-entrepreneurs",
    suggestion: "suggestion",
    faq_page: "faq-page",
    cookie: "cookie",
    data_security: "data-security",
    privacy: "privacy",
    user_agreement: "user-agreement",
    contract: "contract"
  }
};

export const ALL_PATHS = {
  home: "home",
  tr: "home",
  en: "home",
  fiyatlandirma: "pricing",
  pricing: "pricing",

  marketplace_integration: "marketplace-integration",
  pazaryeri_cozumleri: "marketplace-integration",

  shipping_integration: "shipping-integration",
  kargo_entegrasyonlari: "shipping-integration",

  xml_integration: "xml-integration",
  xml_entegrasyonlari: "xml-integration",

  webservice_integration: "webservice-integration",
  webservis_entegrasyonu: "webservis-integration",

  analytics_integration: "analytics-integration",
  analistik_entegrasyonlari: "analytics-integration",

  catalog_management: "catalog-management",
  katalog_yonetimi: "catalog-management",

  stock_and_price_management: "stock-and-price-management",
  stok_ve_fiyat_yonetimi: "stock-and-price-management",

  order_management: "order-management",
  siparis_yonetimi: "order-management",

  accounting: "accounting",
  on_muhasebe_sistemi: "accounting",

  e_invoice_integration: "e-invoice-integration",
  e_fatura_aktarim_sistemi: "e-invoice-integration",

  contact: "contact",
  iletisim: "contact",

  trendyol_integration: "trendyol-integration",
  trendyol_entegrasyonu: "trendyol-integration",

  hepsiburada_integration: "hepsiburada-integration",
  hepsiburada_entegrasyonu: "hepsiburada-integration",

  n11_integration: "n11-integration",
  n11_entegrasyonu: "n11-integration",

  ciceksepeti_integration: "ciceksepeti-integration",
  ciceksepeti_entegrasyonu: "ciceksepeti-integration",

  pttavm_integration: "pttavm-integration",
  pttavm_entegrasyonu: "pttavm-integration",

  akakce_integration: "akakce-integration",
  akakce_entegrasyonu: "akakce-integration",

  amazon_integration: "amazon-integration",
  amazon_entegrasyonu: "amazon-integration",

  rgsyazilim_integration: "rgsyazilim-integration",
  rgsyazilim_entegrasyonu: "rgsyazilim-integration",

  opencart_integration: "opencart-integration",
  opencart_entegrasyonu: "opencart-integration",

  shopify: "shopify",

  shopify_integration: "shopify-integration",
  shopify_entegrasyonu: "shopify-integration",

  shopify_app_development: "shopify-app-development",
  shopify_uygulama_gelistirme: "shopify-app-development",

  shopify_store_setup: "shopify-store-setup",
  shopify_magaza_kurulumu: "shopify-store-setup",

  shopify_migration: "shopify-migration",
  shopify_gecis: "shopify-migration",

  shopify_theme_development: "shopify-theme-development",
  shopify_tema_gelistirme: "shopify-theme-development",

  shopify_theme_customization: "shopify-theme-customization",
  shopify_tema_ozellestirme: "shopify-theme-customization",

  shopify_maintenance: "shopify-maintenance",
  shopify_bakim_destek: "shopify-maintenance",

  wix_integration: "wix-integration",
  wix_entegrasyonu: "wix-integration",

  woocommerce_integration: "woocommerce-integration",
  woocommerce_entegrasyonu: "woocommerce-integration",

  paytr_integration: "paytr-integration",
  paytr_entegrasyonu: "paytr-integration",

  bizimhesap_integration: "bizimhesap-integration",
  bizimhesap_entegrasyonu: "bizimhesap-integration",

  dia_integration: "dia-integration",
  dia_entegrasyonu: "dia-integration",

  edm_integration: "edm-integration",
  edm_entegrasyonu: "edm-integration",

  parasut_integration: "parasut-integration",
  parasut_entegrasyonu: "parasut-integration",

  uyumsoft_integration: "uyumsoft-integration",
  uyumsoft_entegrasyonu: "uyumsoft-integration",

  aras_cargo: "aras-cargo",
  aras_kargo: "aras-cargo",

  yurtici_cargo: "yurtici-cargo",
  yurtici_kargo: "yurtici-cargo",

  mng_cargo: "mng-cargo",
  mng_kargo: "mng-cargo",

  ups_cargo: "ups-cargo",
  ups_kargo: "ups-cargo",

  ptt_cargo: "ptt-cargo",
  ptt_kargo: "ptt-cargo",

  hepsijet_cargo: "hepsijet-cargo",
  hepsijet_kargo: "hepsijet-cargo",

  sendeo_cargo: "sendeo-cargo",
  sendeo_kargo: "sendeo-cargo",

  surat_cargo: "surat-cargo",
  surat_kargo: "surat-cargo",

  about: "about",
  hakkimizda: "about",

  career: "career",
  kariyer: "career",

  dealership: "dealership",
  bayilik: "dealership",

  women_entrepreneurs: "women-entrepreneurs",
  kadin_girisimciler: "women-entrepreneurs",

  suggestion: "suggestion",
  oneri_sikayet: "suggestion",

  faq_page: "faq-page",
  sss: "faq-page",

  cookie: "cookie",
  cerez: "cookie",

  data_security: "data-security",
  veri_guvenligi: "data-security",

  privacy: "privacy",
  gizlilik: "privacy",

  user_agreement: "user-agreement",
  kullanici_sozlesmesi: "user-agreement",

  contract: "contract",
  aydinlatma_metni: "contract",
};
